import PropTypes from 'prop-types'
import { Box, FormHelperText, Typography } from '@mui/material'

import Radio from '../../components/radio'
import useStyles from './styles'
import useTranslations from '../../../i18n/useTranslations'
import TooltipButton from '../../components/tooltipButton'
import { useUserContext } from '../../../auth/UserProvider'
import { useEffect } from 'react'
const ServiceRadioButtons = ({
  serviceTypeOptions,
  selectedService,
  shouldShowPrice,
  onChangeService,
  error,
  helperText,
}) => {
  const classes = useStyles()
  const t = useTranslations()
  const user = useUserContext()

  useEffect(() => {
    if (!serviceTypeOptions?.length && selectedService) {
      onChangeService(null)
    }
  }, [
    onChangeService,
    selectedService,
    serviceTypeOptions,
    serviceTypeOptions?.length,
  ])

  return serviceTypeOptions?.length && selectedService ? (
    <>
      {shouldShowPrice && user?.isFinancial ? (
        <Box className={classes.from}>
          <Typography className={classes.label}>
            {t('noun:from')}
            <TooltipButton
              type="primary"
              title={t('tooltip:service-price')}
              arrow
              placement="top"
            />
          </Typography>
        </Box>
      ) : null}
      {serviceTypeOptions.map(serviceType => (
        <Radio
          key={serviceType.code}
          label={serviceType.label}
          subLabel={serviceType.description}
          amount={user?.isFinancial && shouldShowPrice ? serviceType.basePrice : null}
          onChange={() => onChangeService(serviceType)}
          checked={selectedService?.code === serviceType.code}
          className={classes.serviceRadioButtons}
        />
      ))}
      {error && (
        <FormHelperText error variant="body1" sx={{ mt: 3 }}>
          {helperText}
        </FormHelperText>
      )}
    </>
  ) : (
    <Typography>
      {t('shipping-send-form:shipment:wrong-sizes-or-weight')}
    </Typography>
  )
}

ServiceRadioButtons.propTypes = {
  shouldShowPrice: PropTypes.bool,
  serviceTypeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      originalCode: PropTypes.string,
      label: PropTypes.string,
      description: PropTypes.string,
      basePrice: PropTypes.number,
    }),
  ),
  selectedService: PropTypes.shape({
    code: PropTypes.string,
    originalCode: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    basePrice: PropTypes.number,
  }),
  onChangeService: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
}

export default ServiceRadioButtons
